import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FieldWrapper = styled.div`
  width: 100%;
`;

export const FieldDescription = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 20px;
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;
  `}
`;

export const RequirementsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RequirementsTitle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 24px;
    color: ${theme.v2.colors.neutral.lowPure};
  `}
`;

export const RequirementsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RequirementItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;


export const RequirementText = styled.span`
  ${({ theme, isValid }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 21px;
    color: ${isValid ? theme.v2.colors.feedback.activePure : theme.v2.colors.feedback.problemPure};
  `}
`;

export const AlertMessage = styled.div`
  ${({ theme }) => css`
  width: 100%;

  & a {
    color: ${theme.v2.colors.brand.primaryBlue};
    font-weight: ${theme.v2.font.weights.regular};
    text-decoration: none;
  }
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-content: space-between;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
      gap: 16px;

      & > button:first-child {
        order: 2;
      }

      & > button:last-child {
        order: 1;
      }
    }
  `}
`;
